import { Grid, Typography, Chip, Button, Link, IconButton } from "@mui/material"
import moment from "moment"
import { KaziAvatar } from "../../../Shared Components/Kazi/KaziAvatar"
import { formatUserName } from "../../../Utils/String"
import { IJobByStatus } from "../../../Types/Job"
import { useUser } from "../../../Hooks/useUser"
import { ProfileType } from "../../../Types/General"
import { JobCompletionModal } from "./JobCompletionModal"
import { useState } from "react"
import { ChatBubble, ChatBubbleOutlineOutlined, Message } from "@mui/icons-material"
import { useKaziNavigate } from "../../../Hooks/useKaziNavigate"

interface ActiveJobViewProps {
    job: IJobByStatus;
}
export const ActiveJobView = ({ job }: ActiveJobViewProps) => {
    /* ******************** Hooks ******************** */
    const { type } = useUser();
    const { navigateToMessages } = useKaziNavigate();
    const isClient = type == ProfileType.Client;
    /* ******************** Variables ******************** */
    let avatarLocator = '', 
        avatarFirstName = '',
        avatarLastName = ''

    if (isClient) {
        avatarLocator = job.talent.locator;
        avatarFirstName = job.talent.first_name;
        avatarLastName = job.talent.last_name;
    }
    if (!isClient) {
        avatarLocator = job.client.locator;
        avatarFirstName = job.client.first_name;
        avatarLastName = job.client.last_name;
    }

    const [open, setOpen] = useState(false);
    const profileUrl = isClient ? `/profile/talent/${job.talent.locator}` : `/profile/client/${job.client.locator}`
    const username = formatUserName(avatarFirstName, avatarLastName);
    const isComplete = ( !isClient && job.status === 'ready_for_review' ) || ( isClient && job.status !== 'ready_for_review' ) || job.status === 'finished'
    /* ******************** Functions ******************** */    
    const handleComplete = () => {
        setOpen(true);
    }
    const getAvatar = () => {
        return (
            <KaziAvatar 
                locator={avatarLocator}
                first_name={avatarFirstName}
                last_name={avatarLastName}
                width={'32px'}
            />
        )
    }
    const handleMessage = () => {
        navigateToMessages(isClient ? job.talent.locator : job.client.locator)
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>
            <Grid display={'flex'} flexDirection={'row'} marginBottom={1}>
                <Grid flex={1} display={'flex'} flexDirection={'row'} gap={'70px'}> 
                    <Grid display={'flex'} flexDirection={'row'} gap={2}>
                        {getAvatar()}
                        <Grid display={'flex'} flexDirection={'column'}>
                            <Link href={profileUrl}>
                                <Typography variant='body-medium' >
                                    {username}
                                </Typography>
                            </Link>
                            <Typography variant='body-smaller' sx={{color: 'black.300'}}>
                                {job.title}
                            </Typography>
                        </Grid>
                    </Grid>
                    {job.status === 'finished' && <Grid display={'flex'} flexDirection={'column'} justifyContent={'center'}>
                        <Typography variant={'body-small'} sx={{color: 'black.300'}}>Job completed {moment(job.completed_date).local().format('MMM D, YYYY')}</Typography>
                    </Grid>}
                </Grid>
                {job.status != 'finished' &&
                <Grid flex={1} display={'flex'} flexDirection={'row'} justifyContent={'flex-end'} gap={2} alignItems={'center'}> 
                    {job.status === 'ready_for_review' && <Chip label={'PENDING APPROVAL'} size={'small'} sx={{backgroundColor: 'green.50', color: 'green.300'}}  />}
                    {job.status === 'in_progress' &&  <Chip label={'IN PROGRESS'} size={'small'} sx={{backgroundColor: '#1C54E5', color: '#FFF'}}  />}
                    <IconButton
                        onClick={handleMessage}
                    >
                        <ChatBubbleOutlineOutlined 
                            color="primary"
                        />
                    </IconButton>
                    <Button variant={'contained'} disabled={isComplete} onClick={handleComplete}>Complete</Button>
                </Grid>}
            </Grid>
            <JobCompletionModal 
                open={open} 
                setOpen={setOpen} 
                jobInfo={{ 
                    locator: job.locator,
                    name: username,
                    title: job.title,
                    avatar: getAvatar(),
                    jobType: job?.type,
                    userType: type,
                    client_locator: job.client.locator,
                    talent_locator: job.talent.locator
                }}
            />
        </>
    )
}